"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[997],{

/***/ 3997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Body; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./utils/Constants.js
var Constants = __webpack_require__(4953);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/html-react-parser/esm/index.mjs
var esm = __webpack_require__(7311);
;// CONCATENATED MODULE: ./components/FlightRouteDT/index.js
/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable react/no-danger */ 


function FlightRouteDT(props) {
    (0,react.useEffect)(function() {
        if (language && language === "ar") document.body.classList.add("isArabic");
    });
    var ref = (props === null || props === void 0 ? void 0 : props.data) || {}, language = ref.language, tmp = ref.initial_js, initialJS = tmp === void 0 ? "" : tmp, mainDiv = ref.main_div, top_overlay = ref.top_overlay, ccde = ref.ccde, _isGoibibo = ref.isGoibibo, isGoibibo = _isGoibibo === void 0 ? false : _isGoibibo;
    var googleTagId = isGoibibo ? "GTM-5VDCXLQ" : "GTM-NWV3K7C";
    var googletTagString = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n  })(window,document,'script','dataLayer','".concat(googleTagId, "');\n");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            initialJS && initialJS !== "" ? (0,esm/* default */.ZP)(initialJS) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: mainDiv
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: top_overlay
                }
            }),
            ccde && (ccde === "" || ccde === "in" || ccde === "IN") ? /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: googletTagString
                }
            }) : null
        ]
    });
}

// EXTERNAL MODULE: ./utils/CommonUtils.js + 12 modules
var CommonUtils = __webpack_require__(8396);
;// CONCATENATED MODULE: ./components/FlightRoutePWA/index.js
/* eslint-disable react/no-danger */ 



function FlightRoutePWA(props) {
    (0,react.useEffect)(function() {
        if (language && language === "ar") document.body.classList.add("isArabic");
        else {
            document.body.classList.add("bodyClass");
            document.body.id = "cmsintlflt";
            document.body.setAttribute("data-domain", "www_intl_flight_makemytrip_com");
        }
    });
    var ref = props === null || props === void 0 ? void 0 : props.data, language = ref.language, contentBottom = ref.contentBottom, contentTop = ref.contentTop, contentMiddle = ref.contentMiddle, top_overlay = ref.top_overlay, leftBlock = ref.leftBlock, rightBlock = ref.rightBlock, bottomBlock = ref.bottomBlock, tmp = ref.initial_js, initialJS = tmp === void 0 ? "" : tmp, mainDiv = ref.main_div, appConfig = ref.appConfig, ccde = ref.ccde, _isGoibibo = ref.isGoibibo, isGoibibo = _isGoibibo === void 0 ? false : _isGoibibo;
    var jsPath;
    var cssPath;
    if (appConfig === null || appConfig === void 0 ? void 0 : appConfig.liveMode) {
        jsPath = "https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/js";
        cssPath = "https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/css";
    } else {
        jsPath = "http://localhost:3000/_next/static/js";
        cssPath = "http://localhost:3000/_next/static/css";
    }
    var intentOfferOverlayCSSPath = "".concat(cssPath, "/intentOfferOverlay.min.css");
    var intentOfferOverlayJSPath = "".concat(jsPath, "/intentOffer.min.js");
    var googleTagId = isGoibibo ? "GTM-5VDCXLQ" : "GTM-NWV3K7C";
    var googletTagString = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n  })(window,document,'script','dataLayer','".concat(googleTagId, "');\n");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            initialJS && initialJS !== "" ? (0,esm/* default */.ZP)(initialJS) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: mainDiv
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fli-intl-container prepend_top20 clearfix",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "fli-intl-lhs pull-left",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "seoOnlyBlock col-lg-9 col-md-12 col-sm-12 col-xs-12",
                            children: [
                                (0,CommonUtils/* transformToHtml */.cR)(contentTop),
                                (0,CommonUtils/* transformToHtml */.cR)(contentMiddle),
                                (0,CommonUtils/* transformToHtml */.cR)(contentBottom),
                                (0,CommonUtils/* transformToHtml */.cR)(bottomBlock)
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "seoOnlyBlock col-lg-3 col-md-12 col-sm-12 col-xs-12",
                            children: [
                                (0,CommonUtils/* transformToHtml */.cR)(leftBlock),
                                (0,CommonUtils/* transformToHtml */.cR)(rightBlock)
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: top_overlay
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "overlay_hamburger"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                id: "back-top",
                className: "back-to-top",
                children: "\xa0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                href: "".concat(intentOfferOverlayCSSPath),
                rel: "stylesheet"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                defer: true,
                type: "text/javascript",
                src: "".concat(intentOfferOverlayJSPath)
            }),
            ccde && (ccde === "" || ccde === "in" || ccde === "IN") ? /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: googletTagString
                }
            }) : null
        ]
    });
}

;// CONCATENATED MODULE: ./components/FareFinderDT/index.js
/* eslint-disable react/no-danger */ 


function FareFinderDT(props) {
    (0,react.useEffect)(function() {
        if (language && language === "ar") document.body.classList.add("isArabic");
    });
    var ref = (props === null || props === void 0 ? void 0 : props.data) || {}, language = ref.language, mainDiv = ref.main_div, tmp = ref.initial_js, initialJS = tmp === void 0 ? "" : tmp, top_overlay = ref.top_overlay;
    ;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            initialJS && initialJS !== "" ? (0,esm/* default */.ZP)(initialJS) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: mainDiv
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: top_overlay
                }
            })
        ]
    });
}
;

;// CONCATENATED MODULE: ./components/FlightDistanceDT/Error.js

function ErrorFlightDistanceDT() {
    var errorMessage = '<div id="fullpage-error" class="fullpage-error-wrapper">\n    <div class="fullpage-error-container">\n        <span class="fullpage-error-icon" style="background-image: url(/seo/assets/img/ic_nocompatible_full.png);"></span>\n        <p class="error-title"> Sorry No flights found</p>\n        <div class="error-cta-wrapper">\n            </div>\n    </div>\n</div>';
    return (0,CommonUtils/* transformToHtml */.cR)(errorMessage);
}

;// CONCATENATED MODULE: ./components/FlightDistanceDT/Token.js
/* eslint-disable react/no-danger */ 
function Token(props) {
    var ref;
    var ref1 = (props === null || props === void 0 ? void 0 : (ref = props.data) === null || ref === void 0 ? void 0 : ref.data) || {}, tokenJson = ref1.tokenJson, intid = ref1.intid, devId = ref1.devId, mcid = ref1.mcid, isDeviceMobile = ref1.isDeviceMobile;
    // const isDom = tokenJson.src_country_code === 'IN' ? 'Y' : 'N';
    // if (tokenJson.src_city_code) {
    //   tokenStringUtil = `var isDom = "${tokenJson.src_country_code === 'IN' ? 'Y' : 'N'}";
    //   var prefilledSrcCity = '{"country":"' ${tokenJson.src_country_name} '","iata":"'
    //       ${tokenJson.src_city_code} '","iata_label":"'
    //       ${tokenJson.src_city_name} ', ' ${tokenJson.src_country_name} ' ('
    //       ${tokenJson.src_city_code} ')","isDom":"'${isDom}'","fph_cd_s":"'
    //       ${tokenJson.src_city_code} '","city":"'
    //       ${tokenJson.src_city_name} '","fph_cty_s":"' ${tokenJson.src_country_code} '"}';`;
    // }
    // if (tokenJson.dest_city_code) {
    //   tokenStringUtil = `var isDom = "${tokenJson.dest_country_code === 'IN' ? 'Y' : 'N'}";
    //   var prefilledSrcCity = '{"country":"' ${tokenJson.dest_country_name} '","iata":"'
    //       ${tokenJson.dest_country_name} '","iata_label":"'
    //       ${tokenJson.dest_city_name} ', ' ${tokenJson.dest_country_name} ' ('
    //       ${tokenJson.dest_country_name} ')","isDom":"'${isDom}'","fph_cd_s":"'
    //       ${tokenJson.dest_country_name} '","city":"'
    //       ${tokenJson.dest_city_name} '","fph_cty_s":"' ${tokenJson.dest_country_code} '"}';`;
    // }
    var tokenString = "\n  var tokenJson = ".concat(JSON.stringify(tokenJson), ';\n  var intid = "').concat(intid || "", '";\n  var mmt = {};\n  mmt.hlp = {};\n  var devId = "').concat(devId, '";\n  var mcid = "').concat(mcid, '";\n  var device = "').concat(!isDeviceMobile ? "desktop" : "mobile", "\";\n  if(tokenJson.src_city_code){\n    var isDom = (tokenJson.src_country_code == 'IN') ? 'Y' : 'N';\n    var prefilledSrcCity = '{\"country\":\"'+ tokenJson.src_country_name + '\",\"iata\":\"'\n        + tokenJson.src_city_code + '\",\"iata_label\":\"'\n        + tokenJson.src_city_name + ', '+ tokenJson.src_country_name + ' ('\n        + tokenJson.src_city_code + ')\",\"isDom\":\"'+isDom+'\",\"fph_cd_s\":\"'\n        + tokenJson.src_city_code + '\",\"city\":\"'\n        + tokenJson.src_city_name + '\",\"fph_cty_s\":\"'+ tokenJson.src_country_code + '\"}';\n    }\n  if(tokenJson.dest_city_code){\n    var isDomDest = (tokenJson.dest_country_code == 'IN') ? 'Y' : 'N';\n    var prefilledDestCity = '{\"country\":\"'+ tokenJson.dest_country_name + '\",\"iata\":\"'\n        + tokenJson.dest_city_code + '\",\"iata_label\":\"'\n        + tokenJson.dest_city_name + ', '+ tokenJson.dest_country_name + ' ('\n        + tokenJson.dest_city_code + ')\",\"isDom\":\"'+isDomDest+'\",\"fph_cd_s\":\"'\n        + tokenJson.dest_city_code + '\",\"city\":\"'\n        + tokenJson.dest_city_name + '\",\"fph_cty_s\":\"'+ tokenJson.dest_country_code + '\"}';\n  }\n  var pageType = 'home', WEBSITE_URL = '//www.makemytrip.com', funnel_URL = '', mouseRecorder = '', serverTodayDate = new Date(), serverTime = new Date(), noOfDaysToAddInDept = ").concat(tokenJson.noOfDaysToAddInDept, ", noOfDaysToAddInReturn = ").concat(tokenJson.noOfDaysToAddInReturn, ";\n  ");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            dangerouslySetInnerHTML: {
                __html: tokenString
            }
        })
    });
}

;// CONCATENATED MODULE: ./components/FlightDistanceDT/index.js
/* eslint-disable @next/next/no-sync-scripts */ /* eslint-disable react/no-danger */ /* eslint-disable react-hooks/exhaustive-deps */ 



function FlightDistanceDT(props) {
    var ref = (props === null || props === void 0 ? void 0 : props.data) || {}, appConfig = ref.appConfig, mainDiv = ref.main_div, seoContentDesc = ref.seo_content_desc, activeDate = ref.activeDate, srcCoordinates = ref.srcCoordinates, destCoordinates = ref.destCoordinates, blocksData = ref.blocksData, lang = ref.lang, ccde = ref.ccde, _isGoibibo = ref.isGoibibo, isGoibibo = _isGoibibo === void 0 ? false : _isGoibibo;
    var cssPath;
    var jsPath;
    // let imagePath;
    // let minExt;
    var lazyLoadingPath;
    var topOverlayPath;
    var seoWidgetPath;
    if (appConfig && appConfig.liveMode) {
        cssPath = "https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/css";
        jsPath = "https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/js";
    // imagePath = `${appConfig.imagePath}/images`;
    // minExt = '.min';
    } else {
        cssPath = "http://localhost:3000/_next/static/css";
        jsPath = "http://localhost:3000/_next/static/js";
    // imagePath = '/images';
    // minExt = '';
    }
    lazyLoadingPath = "".concat(jsPath, "/lazyLoading.min.js");
    topOverlayPath = isGoibibo ? "".concat(jsPath, "/topOverlayGI.min.js") : "".concat(jsPath, "/top_overlay.min.js");
    seoWidgetPath = lang === "hin" ? "".concat(jsPath, "/hiSeoWidget2.min.js") : "".concat(jsPath, "/seoWidget2.min.js");
    var intentOfferOverlayCSSPath = "".concat(cssPath, "/intentOfferOverlay.min.css");
    var intentOfferOverlayJSPath = "".concat(jsPath, "/intentOffer.min.js");
    var googleTagId = isGoibibo ? "GTM-5VDCXLQ" : "GTM-NWV3K7C";
    var googleTagSrc = "https://www.googletagmanager.com/ns.html?id=".concat(googleTagId);
    var googletTagString = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n  })(window,document,'script','dataLayer','".concat(googleTagId, "');\n  ");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            ccde || ccde === "in" || ccde === "IN" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("noscript", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    title: "distance",
                    src: googleTagSrc,
                    height: "0",
                    width: "0",
                    style: {
                        display: "none",
                        visibility: "hidden"
                    }
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: "\n      var srcCoordinates = ".concat(JSON.stringify(srcCoordinates), ";\n      var destCoordinates = ").concat(JSON.stringify(destCoordinates), ";\n      ")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "newSection",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fare-section marginTop126 hidden-xs",
                        id: "seoContentDesc",
                        children: (0,CommonUtils/* transformToHtml */.cR)(seoContentDesc)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        id: "fare-header",
                        class: "weekly-fare-section container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                class: "mobile-header",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    class: "makeFlex hrtlCenter",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "https://www.makemytrip.com/flights/",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                class: "back-button header-back-icon"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            class: "trip-details",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                class: "trip-summary font12",
                                                children: lang === "hin" ? "".concat(activeDate && activeDate !== "" ? "|" : "", " 1 वयस्क | इकोनॉमी") : "".concat(activeDate && activeDate !== "" ? "|" : "", " 1 Adult | Economy")
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                class: "makeFlex FareStrip",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    class: "weekly-fare-carousel",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        class: "weekly-fare-carousel-container weekly-scroll",
                                        id: "fareStripLoader",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            class: "placeholder-content",
                                            id: "placeholder"
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fli-intl-container clearfix",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "fli-intl-lhs",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            class: "seoOnlyBlock airline-left-container nopadding-mob paddR0 ",
                            children: [
                                mainDiv && mainDiv !== "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: mainDiv
                                    }
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorFlightDistanceDT, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: blocksData.contentTop
                                    }
                                }),
                                mainDiv && mainDiv !== "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: blocksData.contentMiddle
                                    }
                                }) : "",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: blocksData.contentBottom
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: blocksData.bottomBlock
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            class: "seoOnlyBlock col-lg-3 col-md-12 col-sm-12 col-xs-12 airline-right-container nopadding-mob paddR0 ",
                            children: [
                                (0,CommonUtils/* transformToHtml */.cR)(blocksData.rightBlock),
                                (0,CommonUtils/* transformToHtml */.cR)(blocksData.leftBlock)
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Token, {
                data: props
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                defer: true,
                type: "text/javascript",
                src: "".concat(lazyLoadingPath)
            }),
            lang === "hin" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                    children: "\n            .filter-options .ui-datepicker {\n                width: 675px!important;\n            }\n            .ui-datepicker-multi-2 .ui-datepicker-group {\n                margin: 14px 22px 0;\n            }\n            .filter-options .ui-datepicker .ui-datepicker-header .ui-datepicker-title {\n                font-size: 18px !important;\n                font-weight: bolder !important;\n                color: #000 !important;\n                text-align: center !important;\n            }\n            .filter-options .ui-datepicker .ui-datepicker-header .ui-datepicker-title .ui-datepicker-year {\n                font-size: 18px !important;\n                font-weight: bolder !important;\n                color: #000 !important;\n                text-align: center !important;\n            }\n            .modify-search-label {\n                line-height: 18px !important;\n            }\n            .filter-options .ui-datepicker-calendar thead th {\n                font-size: 1em;\n            }\n\n            .modify-search-input-field {\n                line-height: 21px !important;\n            }"
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "text/javascript",
                src: "".concat(seoWidgetPath)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                defer: true,
                type: "text/javascript",
                src: "".concat(topOverlayPath)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "seo-bottom",
                class: "seo",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    name: "domain_id",
                    id: "domain_id",
                    type: "hidden",
                    value: "www_intl_flight_makemytrip_com"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                href: "".concat(intentOfferOverlayCSSPath),
                rel: "stylesheet"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                defer: true,
                type: "text/javascript",
                src: "".concat(intentOfferOverlayJSPath)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: blocksData.top_overlay
                }
            }),
            ccde && (ccde === "" || ccde === "in" || ccde === "IN") ? /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: googletTagString
                }
            }) : null
        ]
    });
}

;// CONCATENATED MODULE: ./components/CityDT/index.js
/* eslint-disable react/no-danger */ 


function CityDT(props) {
    (0,react.useEffect)(function() {
        document.body.classList.add("bodyClass");
        document.body.id = "cmsintlflt";
        document.body.setAttribute("data-domain", "www_intl_flight_makemytrip_com");
    });
    var ref = (props === null || props === void 0 ? void 0 : props.data) || {}, blocksData = ref.blocksData, content = ref.content;
    var containerRef = (0,react.useRef)(null);
    var middleBlockHtml = "".concat((blocksData === null || blocksData === void 0 ? void 0 : blocksData.contentTop) ? blocksData.contentTop : "").concat((blocksData === null || blocksData === void 0 ? void 0 : blocksData.contentMiddle) ? blocksData.contentMiddle : "").concat(content ? content : "").concat((blocksData === null || blocksData === void 0 ? void 0 : blocksData.contentBottom) ? blocksData.contentBottom : "").concat((blocksData === null || blocksData === void 0 ? void 0 : blocksData.bottomBlock) ? blocksData.bottomBlock : "");
    (0,react.useEffect)(function() {
        var ref;
        var buttons = (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll(".ViewFareBtn");
        if (buttons) {
            buttons === null || buttons === void 0 ? void 0 : buttons.forEach(function(button) {
                var url = button.getAttribute("data-url");
                if (url) {
                    button.onclick = function() {
                        return window.location.replace(url);
                    };
                }
            });
        }
    }, [
        middleBlockHtml
    ]);
    // Before passing, make sure the string has data-url instead of onclick
    var sanitizedHtml = middleBlockHtml.replace(/onclick="[^"]*"/, "");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fli-intl-container prepend_top20 clearfix listingContainer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "makeCenterCol clearfix noPadding",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "seoContentMiddle",
                            className: "seoOnlyBlock col-lg-9 col-md-12 col-sm-12 col-xs-12 paddL0 airline-left-container nopadding-mob paddR0 ",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: containerRef,
                                children: (0,CommonUtils/* transformToHtml */.cR)(sanitizedHtml)
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            id: "seoRightBlock",
                            className: "seoOnlyBlock col-lg-3 col-md-12 col-sm-12 col-xs-12 airline-right-container nopadding-mob paddR0 ",
                            children: [
                                (0,CommonUtils/* transformToHtml */.cR)(blocksData === null || blocksData === void 0 ? void 0 : blocksData.filterBlock),
                                (0,CommonUtils/* transformToHtml */.cR)(blocksData === null || blocksData === void 0 ? void 0 : blocksData.rightBlock),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: blocksData === null || blocksData === void 0 ? void 0 : blocksData.leftBlock
                                    }
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: blocksData === null || blocksData === void 0 ? void 0 : blocksData.top_overlay
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "seo-bottom",
                className: "seo",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    name: "domain_id",
                    id: "domain_id",
                    type: "hidden",
                    value: "www_intl_flight_makemytrip_com"
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/CityCountryDT/index.js
/* eslint-disable react/no-danger */ 

function CityCountryDT(props) {
    var ref = (props === null || props === void 0 ? void 0 : props.data) || {}, mainDiv = ref.main_div, tmp = ref.initial_js, initialJS = tmp === void 0 ? "" : tmp, top_overlay = ref.top_overlay;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            initialJS && initialJS !== "" ? (0,esm/* default */.ZP)(initialJS) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: mainDiv
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: top_overlay
                }
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/offers/index.js
/* eslint-disable react/no-danger */ 



function Offers(props) {
    var ref = (props === null || props === void 0 ? void 0 : props.data) || {}, mainDiv = ref.main_div, appData = ref.appData, apiUrl = ref.apiUrl, _devId = ref.devId, devId = _devId === void 0 ? "" : _devId, _mcid = ref.mcid, mcid = _mcid === void 0 ? "" : _mcid, ccde = ref.ccde, state = ref.state, _appConfig = ref.appConfig, appConfig = _appConfig === void 0 ? {} : _appConfig, lang = ref.lang, device = ref.device, headingAndSearchBar = ref.heading_and_searchbar, intid = ref.intid, contentTop = ref.contentTop, contentMiddle = ref.contentMiddle, contentBottom = ref.contentBottom, bottomBlock = ref.bottomBlock, topOverlay = ref.top_overlay, initialJS = ref.initial_js, tokenJson = ref.tokenJson;
    var isDesktop = device === "desktop";
    var isLive = appConfig.liveMode;
    var srcWidget = "";
    if (isLive) {
        if (isDesktop) {
            srcWidget = lang === "hin" ? "https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/js/hiStaticSeoWidget.min.js" : "https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/js/staticSeoWidget.min.js";
        } else {
            srcWidget = lang === "hin" ? "https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/js/hiStaticSeoWidgetMob.min.js" : "https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/js/staticSeoWidgetMob.min.js";
        }
    } else if (isDesktop) {
        srcWidget = lang === "hin" ? "http://localhost:3000/_next/static/js/hiStaticSeoWidget.min.js" : "http://localhost:3000/_next/static/js/staticSeoWidget.min.js";
    } else {
        srcWidget = lang === "hin" ? "http://localhost:3000/_next/static/js/hiStaticSeoWidgetMob.min.js" : "http://localhost:3000/_next/static/js/staticSeoWidgetMob.min.js";
    }
    (0,react.useEffect)(function() {
        var bodyElement = document.body;
        bodyElement.id = "cmsintlflt";
        bodyElement.className = "bodyClass";
        bodyElement.setAttribute("data-domain", "www_intl_flight_makemytrip_com");
    }, []);
    var scriptTransform = {
        transform: function(node) {
            if (node.type === "script") {
                var ref, ref1;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    defer: true,
                    src: node === null || node === void 0 ? void 0 : (ref = node.attribs) === null || ref === void 0 ? void 0 : ref.src,
                    children: (ref1 = node === null || node === void 0 ? void 0 : node.children[0]) === null || ref1 === void 0 ? void 0 : ref1.data
                });
            }
            return null;
        }
    };
    var stylesDesktop = ".midContainerSpace{\n    height: 0 !important;\n}\n.midContainer {\nwidth: 100%;\npadding: 20px 0;\nmargin-top: -20px;\n}\n@media screen and (min-width: 768px) {\n    .fli-intl-container {\n        padding-top: 0;\n    }\n}\n.lockPriceModalWrapper .arrow::after, .arrow::before {\n    height: 0px !important;\n}\n.widgetSprite {\n    background-position: -5px -5px !important;\n}\n.container {\nmargin-top: 15px;\nwidth: 100%;\n}\n.modify-search-header{\ndisplay: none !important;\n}";
    var stylesMobile = ".modify-search-header {\n    position: relative !important;\n    font-family: Lato-Regular,Arial,Helvetica,sans-serif !important;\n}\n.midContainer {\n    padding: 0 !important;\n    margin-top: -10px !important;\n}\n.widgetSprite {\n    background-position: -5px -5px !important;\n}\n.lndngFltPrgsvWrap--hdr span h1 {\n    font-size: 25px !important;\n}\n.srchForm {\n    box-shadow: none;\n}\n.container {\nmargin-top: 15px;\n/* width: 100%; */\n}";
    //   const script = `
    // $(document).ready(function(){
    //     $(".offersType li").click(function(e){
    //         e.preventDefault();
    //         var $this = $(this);
    //         $this.addClass('active');
    //         $this.addClass('active').siblings().removeClass('active');
    //         $(".allOffers").removeClass('active').hide();
    //         var k=$(this).children('a').attr('href');
    //         $(k).addClass('active').show();
    //         if ($this.hasClass('active')){
    //             $(".allOffers.active").fadeIn("slow");
    //         }
    //     });
    // });
    // `;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: '\n          window.FLTS = {};\n          window.FLTS.listingStartTime = Date.now();\n          window.page = "offers";\n          window.countryCode = \''.concat(ccde, "';\n          window.lang = '").concat(lang, "';\n          window.url ='").concat(apiUrl, "';\n          window.devId = \"").concat(devId || "", '";\n          window.mcid = "').concat(mcid || "", '";\n          window.appData = ').concat(JSON.stringify(appData), ";")
                },
                type: "text/javascript"
            }),
            initialJS && initialJS !== "" ? (0,esm/* default */.ZP)(initialJS) : null,
            isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                dangerouslySetInnerHTML: {
                    __html: stylesDesktop
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                dangerouslySetInnerHTML: {
                    __html: stylesMobile
                }
            }),
            isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                className: "newSection modify-search-header",
                id: "orderHeader",
                children: (0,CommonUtils/* transformToHtml */.cR)(headingAndSearchBar)
            }) : // <header className="modify-search-header" id="orderHeader">
            //   { transformToHtml(headingAndSearchBar) }
            // </header>
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                dangerouslySetInnerHTML: {
                    __html: headingAndSearchBar
                },
                className: "modify-search-header",
                id: "orderHeader"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "midContainer",
                children: [
                    (0,CommonUtils/* transformToHtml */.cR)(contentTop),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: mainDiv
                        }
                    }),
                    (0,CommonUtils/* transformToHtml */.cR)(contentMiddle),
                    contentBottom && bottomBlock && bottomBlock.length > 0 && contentBottom.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container offersWrapper",
                        children: [
                            (0,CommonUtils/* transformToHtml */.cR)(contentBottom),
                            (0,CommonUtils/* transformToHtml */.cR)(bottomBlock)
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                ]
            }),
            (0,CommonUtils/* transformToHtml */.cR)(topOverlay),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: "window.showLeaveIntent = true;"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: "\n      var tokenJson = ".concat(tokenJson ? JSON.stringify(tokenJson) : '{"dest_city_name":"Mumbai","src_city_code":"DEL","dest_city_code":"BOM","src_city_name":"New Delhi"};', '\n      var intid = "').concat(intid, '";\n      var mmt = window.mmt || {};\n      mmt.hlp = mmt.hlp || {};\n      var device = "').concat(device, "\";\n      var pageType = 'home', WEBSITE_URL = '//www.makemytrip.com', funnel_URL = '', mouseRecorder = '', serverTodayDate = ").concat(JSON.stringify(new Date()), ", serverTime = ").concat(JSON.stringify(new Date()), ", noOfDaysToAddInDept = ").concat((tokenJson === null || tokenJson === void 0 ? void 0 : tokenJson.noOfDaysToAddInDept) || "", ", noOfDaysToAddInReturn = ").concat((tokenJson === null || tokenJson === void 0 ? void 0 : tokenJson.noOfDaysToAddInReturn) || "", "\n      ")
                },
                type: "text/javascript"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "overlay_hamburger"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                id: "back-top",
                className: "back-to-top",
                children: "\xa0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                defer: true,
                type: "text/javascript",
                src: "".concat(srcWidget)
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/FlightDistancePWA/Error.js

function Error_ErrorFlightDistanceDT() {
    var errorMessage = '<div id="fullpage-error" class="fullpage-error-wrapper">\n    <div class="fullpage-error-container">\n        <span class="fullpage-error-icon" style="background-image: url(/seo/assets/img/ic_nocompatible_full.png);"></span>\n        <p class="error-title"> Sorry No flights found</p>\n        <div class="error-cta-wrapper">\n            </div>\n    </div>\n</div>';
    return (0,CommonUtils/* transformToHtml */.cR)(errorMessage);
}

;// CONCATENATED MODULE: ./components/FlightDistancePWA/Token.js
/* eslint-disable react/no-danger */ 
function Token_Token(props) {
    var ref;
    var ref1 = (props === null || props === void 0 ? void 0 : (ref = props.data) === null || ref === void 0 ? void 0 : ref.data) || {}, tokenJson = ref1.tokenJson, intid = ref1.intid, devId = ref1.devId, mcid = ref1.mcid, isDeviceMobile = ref1.isDeviceMobile;
    // const isDom = tokenJson.src_country_code === 'IN' ? 'Y' : 'N';
    // if (tokenJson.src_city_code) {
    //   tokenStringUtil = `var isDom = "${tokenJson.src_country_code === 'IN' ? 'Y' : 'N'}";
    //   var prefilledSrcCity = '{"country":"' ${tokenJson.src_country_name} '","iata":"'
    //       ${tokenJson.src_city_code} '","iata_label":"'
    //       ${tokenJson.src_city_name} ', ' ${tokenJson.src_country_name} ' ('
    //       ${tokenJson.src_city_code} ')","isDom":"'${isDom}'","fph_cd_s":"'
    //       ${tokenJson.src_city_code} '","city":"'
    //       ${tokenJson.src_city_name} '","fph_cty_s":"' ${tokenJson.src_country_code} '"}';`;
    // }
    // if (tokenJson.dest_city_code) {
    //   tokenStringUtil = `var isDom = "${tokenJson.dest_country_code === 'IN' ? 'Y' : 'N'}";
    //   var prefilledSrcCity = '{"country":"' ${tokenJson.dest_country_name} '","iata":"'
    //       ${tokenJson.dest_country_name} '","iata_label":"'
    //       ${tokenJson.dest_city_name} ', ' ${tokenJson.dest_country_name} ' ('
    //       ${tokenJson.dest_country_name} ')","isDom":"'${isDom}'","fph_cd_s":"'
    //       ${tokenJson.dest_country_name} '","city":"'
    //       ${tokenJson.dest_city_name} '","fph_cty_s":"' ${tokenJson.dest_country_code} '"}';`;
    // }
    var tokenString = "\n  var tokenJson = ".concat(JSON.stringify(tokenJson), ';\n  var intid = "').concat(intid || "", '";\n  var mmt = {};\n  mmt.hlp = {};\n  var devId = "').concat(devId, '";\n  var mcid = "').concat(mcid, '";\n  var device = "').concat(!isDeviceMobile ? "desktop" : "mobile", "\";\n  if(tokenJson.src_city_code){\n    var isDom = (tokenJson.src_country_code == 'IN') ? 'Y' : 'N';\n    var prefilledSrcCity = '{\"country\":\"'+ tokenJson.src_country_name + '\",\"iata\":\"'\n        + tokenJson.src_city_code + '\",\"iata_label\":\"'\n        + tokenJson.src_city_name + ', '+ tokenJson.src_country_name + ' ('\n        + tokenJson.src_city_code + ')\",\"isDom\":\"'+isDom+'\",\"fph_cd_s\":\"'\n        + tokenJson.src_city_code + '\",\"city\":\"'\n        + tokenJson.src_city_name + '\",\"fph_cty_s\":\"'+ tokenJson.src_country_code + '\"}';\n    }\n  if(tokenJson.dest_city_code){\n    var isDomDest = (tokenJson.dest_country_code == 'IN') ? 'Y' : 'N';\n    var prefilledDestCity = '{\"country\":\"'+ tokenJson.dest_country_name + '\",\"iata\":\"'\n        + tokenJson.dest_city_code + '\",\"iata_label\":\"'\n        + tokenJson.dest_city_name + ', '+ tokenJson.dest_country_name + ' ('\n        + tokenJson.dest_city_code + ')\",\"isDom\":\"'+isDomDest+'\",\"fph_cd_s\":\"'\n        + tokenJson.dest_city_code + '\",\"city\":\"'\n        + tokenJson.dest_city_name + '\",\"fph_cty_s\":\"'+ tokenJson.dest_country_code + '\"}';\n  }\n  var pageType = 'home', WEBSITE_URL = '//www.makemytrip.com', funnel_URL = '', mouseRecorder = '', serverTodayDate = new Date(), serverTime = new Date(), noOfDaysToAddInDept = ").concat(tokenJson.noOfDaysToAddInDept, ", noOfDaysToAddInReturn = ").concat(tokenJson.noOfDaysToAddInReturn, ";\n  ");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            dangerouslySetInnerHTML: {
                __html: tokenString
            }
        })
    });
}

;// CONCATENATED MODULE: ./components/FlightDistancePWA/index.js
/* eslint-disable @next/next/no-sync-scripts */ /* eslint-disable react/no-danger */ /* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable @next/next/no-img-element */ // import { useEffect, useState } from 'react';




function FlightDistancePWA(props) {
    var ref = (props === null || props === void 0 ? void 0 : props.data) || {}, blocksData = ref.blocksData, lang = ref.lang, ccde = ref.ccde, appConfig = ref.appConfig, mainDiv = ref.main_div, seoContentDesc = ref.seo_content_desc, activeDate = ref.activeDate, headingAndSearchBar = ref.heading_and_searchbar, srcCoordinates = ref.srcCoordinates, destCoordinates = ref.destCoordinates, _isGoibibo = ref.isGoibibo, isGoibibo = _isGoibibo === void 0 ? false : _isGoibibo;
    // const [isClient, setIsClient] = useState(false);
    var cssPath;
    var jsPath;
    // let imagePath;
    // let minExt;
    var lazyLoadingPath;
    var topOverlayPath;
    var seoWidgetPath;
    if (appConfig && appConfig.liveMode) {
        cssPath = "https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/css";
        jsPath = "https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/js";
    // imagePath = `${appConfig.imagePath}/images`;
    // minExt = '.min';
    } else {
        cssPath = "http://localhost:3000/_next/static/css";
        jsPath = "http://localhost:3000/_next/static/js";
    // imagePath = '/images';
    // minExt = '';
    }
    lazyLoadingPath = "".concat(jsPath, "/lazyLoading.min.js");
    topOverlayPath = isGoibibo ? "".concat(jsPath, "/topOverlayGI.min.js") : "".concat(jsPath, "/top_overlay.min.js");
    seoWidgetPath = lang === "hin" ? "".concat(jsPath, "/hiSeoWidget2.min.js") : "".concat(jsPath, "/seoWidget2.min.js");
    var intentOfferOverlayCSSPath = "".concat(cssPath, "/intentOfferOverlay.min.css");
    var intentOfferOverlayJSPath = "".concat(jsPath, "/intentOffer.min.js");
    // const mapPath = appConfig?.liveMode ? `${appConfig.jsPath}/js/flight-assets/map.js?v=${appConfig.resourceVersion}` : '/js/core/map.js';
    var googleTagId = isGoibibo ? "GTM-5VDCXLQ" : "GTM-NWV3K7C";
    var googleTagSrc = "https://www.googletagmanager.com/ns.html?id=".concat(googleTagId);
    var googletTagString = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n    })(window,document,'script','dataLayer','".concat(googleTagId, "');");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            ccde || ccde === "in" || ccde === "IN" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("noscript", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    title: "distance",
                    src: googleTagSrc,
                    height: "0",
                    width: "0",
                    style: {
                        display: "none",
                        visibility: "hidden"
                    }
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: "\n      var srcCoordinates = ".concat(JSON.stringify(srcCoordinates), ";\n      var destCoordinates = ").concat(JSON.stringify(destCoordinates), ";\n      ")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "newSection",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                        class: "modify-search-header",
                        id: "orderHeader",
                        dangerouslySetInnerHTML: {
                            __html: headingAndSearchBar
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fare-section marginTop126 hidden-xs",
                        id: "seoContentDesc",
                        children: (0,CommonUtils/* transformToHtml */.cR)(seoContentDesc)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        id: "fare-header",
                        class: "weekly-fare-section container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                class: "mobile-header",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    class: "makeFlex hrtlCenter",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "https://www.makemytrip.com/flights/",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                class: "back-button header-back-icon"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            class: "trip-details",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                class: "trip-summary font12",
                                                children: lang === "hin" ? "".concat(activeDate && activeDate !== "" ? "".concat(activeDate, " | ") : "", "1 वयस्क | इकोनॉमी") : "".concat(activeDate && activeDate !== "" ? "".concat(activeDate, " | ") : "", "1 Adult | Economy")
                                            })
                                        }),
                                        lang === "hin" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            class: "hi-btn-wrp",
                                            onclick: "handleEngClick()",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "https://imgak.mmtcdn.com/flights/assets/media/mobile/seo/hiLang.png",
                                                    alt: ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "ENG"
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                class: "makeFlex FareStrip",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    class: "weekly-fare-carousel",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        class: "weekly-fare-carousel-container weekly-scroll",
                                        id: "fareStripLoader",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            class: "placeholder-content",
                                            id: "placeholder"
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "main {\n          margin-bottom: 20px;\n        }"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fli-intl-container clearfix",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "fli-intl-lhs",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            class: "seoOnlyBlock airline-left-container nopadding-mob paddR0 ",
                            children: [
                                mainDiv && mainDiv !== "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: mainDiv
                                    }
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Error_ErrorFlightDistanceDT, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: blocksData.contentTop
                                    }
                                }),
                                mainDiv && mainDiv !== "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: blocksData.contentMiddle
                                    }
                                }) : "",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: blocksData.contentBottom
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: blocksData.bottomBlock
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            class: "seoOnlyBlock col-lg-3 col-md-12 col-sm-12 col-xs-12 airline-right-container nopadding-mob paddR0 ",
                            children: [
                                (0,CommonUtils/* transformToHtml */.cR)(blocksData.rightBlock),
                                (0,CommonUtils/* transformToHtml */.cR)(blocksData.leftBlock)
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Token_Token, {
                data: props
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                defer: true,
                type: "text/javascript",
                src: "".concat(lazyLoadingPath)
            }),
            lang === "hin" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                    children: ".filter-options .ui-datepicker .ui-datepicker-header .ui-datepicker-title {\n                font-size: 18px !important;\n                font-weight: bolder !important;\n                color: #000 !important;\n                text-align: center !important;\n            }\n            .filter-options .ui-datepicker .ui-datepicker-header .ui-datepicker-title .ui-datepicker-year {\n                font-size: 18px !important;\n                font-weight: bolder !important;\n                color: #000 !important;\n                text-align: center !important;\n            }\n            .modify-search-label {\n                line-height: 18px !important;\n            }\n            .filter-options .ui-datepicker-calendar thead th {\n                font-size: 1em;\n            }\n\n            .modify-search-input-field {\n                line-height: 21px !important;\n            }"
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "text/javascript",
                src: "".concat(seoWidgetPath)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                defer: true,
                type: "text/javascript",
                src: "".concat(topOverlayPath)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "seo-bottom",
                class: "seo",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    name: "domain_id",
                    id: "domain_id",
                    type: "hidden",
                    value: "www_intl_flight_makemytrip_com"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                href: "".concat(intentOfferOverlayCSSPath),
                rel: "stylesheet"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                defer: true,
                type: "text/javascript",
                src: "".concat(intentOfferOverlayJSPath)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: blocksData.top_overlay
                }
            }),
            ccde && (ccde === "" || ccde === "in" || ccde === "IN") ? /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: googletTagString
                }
            }) : null
        ]
    });
}

;// CONCATENATED MODULE: ./components/CityPWA/index.js
/* eslint-disable react/no-danger */ 


function CityPWA(props) {
    (0,react.useEffect)(function() {
        document.body.classList.add("bodyClass");
        document.body.id = "cmsintlflt";
        document.body.setAttribute("data-domain", "www_intl_flight_makemytrip_com");
    });
    var ref = (props === null || props === void 0 ? void 0 : props.data) || {}, blocksData = ref.blocksData, pageData = ref.pageData, isIntl = ref.isIntl, templateType = ref.template_type, ccde = ref.ccde, lang = ref.lang, appConfig = ref.appConfig, tmp = ref.heading_and_searchbar, headingAndSearchBar = tmp === void 0 ? "" : tmp, preLoadedState = ref.preLoadedState, jsSettingJson = ref.jsSettingJson, tokenJson = ref.tokenJson, intid = ref.intid, region = ref.region;
    var cssPath;
    var jsPath;
    // let imagePath;
    // let minExt;
    var bankOfferPath;
    var intentOfferPath;
    var seoListingPath;
    var staticWidgetPath;
    if (appConfig && appConfig.liveMode) {
        cssPath = "https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/css";
        jsPath = "https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/js";
        // imagePath = `${appConfig.imagePath}/images`;
        // minExt = '.min';
        intentOfferPath = "".concat(jsPath, "/intentOffer.min.js");
        seoListingPath = "".concat(cssPath, "/seoListingMob.min.css");
        bankOfferPath = "".concat(cssPath, "/bankOfferMob.min.css");
        staticWidgetPath = lang === "hin" ? "".concat(jsPath, "/hiStaticSeoWidgetMob.min.js") : "".concat(jsPath, "/staticSeoWidgetMob.min.js");
    } else {
        cssPath = "http://localhost:3000/_next/static/css";
        jsPath = "http://localhost:3000/_next/static/js";
        // imagePath = '/images';
        // minExt = '';
        intentOfferPath = "".concat(jsPath, "/intentOffer.min.js");
        seoListingPath = "".concat(cssPath, "/seoListingMob.min.css");
        bankOfferPath = "".concat(cssPath, "/bankOfferMob.min.css");
        staticWidgetPath = lang === "hin" ? "".concat(jsPath, "/hiStaticSeoWidgetMob.min.js") : "".concat(jsPath, "/staticSeoWidgetMob.min.js");
    }
    var tokenJsonString = tokenJson && tokenJson.length !== 0 ? "var tokenJson = ".concat(JSON.stringify(tokenJson)) : 'var tokenJson = {"prefilledDestCity":{"country":"India","iata":"BOM","city":"Mumbai, India","value":"Mumbai (BOM)"},"tokensList":{},"prefilledSrcCity":{"country":"India","iata":"DEL","city":"New Delhi, India","value":"New Delhi (DEL)"}};';
    var containerRef = (0,react.useRef)(null);
    var middleBlockHtml = "".concat((blocksData === null || blocksData === void 0 ? void 0 : blocksData.contentTop) ? blocksData.contentTop : "").concat((blocksData === null || blocksData === void 0 ? void 0 : blocksData.contentMiddle) ? blocksData.contentMiddle : "").concat((pageData === null || pageData === void 0 ? void 0 : pageData.content) ? pageData.content : "").concat((blocksData === null || blocksData === void 0 ? void 0 : blocksData.contentBottom) ? blocksData.contentBottom : "").concat((blocksData === null || blocksData === void 0 ? void 0 : blocksData.bottomBlock) ? blocksData.bottomBlock : "");
    (0,react.useEffect)(function() {
        var ref;
        var buttons = (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll(".listing-card-wrpr");
        if (buttons) {
            buttons === null || buttons === void 0 ? void 0 : buttons.forEach(function(button) {
                var url = button.getAttribute("data-url");
                if (url) {
                    button.onclick = function() {
                        return window.location.replace(url);
                    };
                }
            });
        }
    }, [
        middleBlockHtml
    ]);
    // Before passing, make sure the string has data-url instead of onclick
    var sanitizedHtml = middleBlockHtml.replace(/onclick="[^"]*"/, "");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: "\n      window.__PRELOADED_STATE__ = '".concat(preLoadedState, "';\n      window.showLeaveIntent = true;\n      var mbox_id = 'New_homepage_Hero', top_mbox_id = 'HPLP_Topbar_New', dealsPerLoad = '12', dealMaxLoad = '48', voyagerURL = '//voyager.goibibo.com/api/v1/flights_search/find_node_by_name_v2/?limit=15&amp;country_filter_id=5597365951189135149', voyagerTimeout = '3000';\n      var jsSettingJson = ").concat(JSON.stringify(jsSettingJson), ";\n      ").concat((appConfig === null || appConfig === void 0 ? void 0 : appConfig.settings) ? "var flightsettings = ".concat(JSON.stringify(appConfig.settings), ";") : "", ";\n      ").concat(tokenJsonString, '\n      var intid = "').concat(intid || "", "\";\n      var mmt = {};\n      mmt.hlp = {};\n      var device = 'desktop';\n      window.isIntl = ").concat(isIntl || false, ";\n      var pageType = 'home', WEBSITE_URL = '//www.makemytrip.com', funnel_URL = '', mouseRecorder = '', serverTodayDate = new Date(), serverTime = new Date(), noOfDaysToAddInDept = tokenJson?.noOfDaysToAddInDept, noOfDaysToAddInReturn = tokenJson?.noOfDaysToAddInReturn;\n      var template = '").concat(templateType, "';\n      window.template = '").concat(templateType, "';\n      let ccdeVal = '").concat(region ? "&ccde=".concat(region) : "&ccde=IN", "';\n      ")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                defer: true,
                type: "text/javascript",
                src: "".concat(staticWidgetPath)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "text/javascript",
                children: "window.FLTS = {};\n        window.FLTS.listingStartTime = Date.now();"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: ".modify-search-header {position: relative;}"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                dangerouslySetInnerHTML: {
                    __html: "".concat(headingAndSearchBar)
                },
                class: "modify-search-header",
                id: "orderHeader"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                defer: true,
                type: "text/javascript",
                src: "".concat(intentOfferPath)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                href: "".concat(seoListingPath),
                rel: "stylesheet"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                href: "".concat(bankOfferPath),
                rel: "stylesheet"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fli-intl-container prepend_top20 clearfix listingContainer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "makeCenterCol clearfix noPadding",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "seoContentMiddle",
                            className: "seoOnlyBlock col-lg-9 col-md-12 col-sm-12 col-xs-12 paddL0 airline-left-container nopadding-mob paddR0 ",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: containerRef,
                                children: (0,CommonUtils/* transformToHtml */.cR)(sanitizedHtml)
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            id: "seoRightBlock",
                            className: "seoOnlyBlock col-lg-3 col-md-12 col-sm-12 col-xs-12 airline-right-container nopadding-mob paddR0 ",
                            children: [
                                (0,CommonUtils/* transformToHtml */.cR)(blocksData === null || blocksData === void 0 ? void 0 : blocksData.filterBlock),
                                (0,CommonUtils/* transformToHtml */.cR)(blocksData === null || blocksData === void 0 ? void 0 : blocksData.rightBlock),
                                (0,CommonUtils/* transformToHtml */.cR)(blocksData === null || blocksData === void 0 ? void 0 : blocksData.leftBlock)
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: blocksData === null || blocksData === void 0 ? void 0 : blocksData.top_overlay
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: '$(document).ready(function(){$(".viewFareBtn").click(function(e){e.preventDefault();$(this);let t=document.getElementsByClassName("hideCheapCards"),n=document.getElementById("viewFareBtn");if(n.parentNode.removeChild(n),t.length>0)for(var a=0;a<=t.length;a++)t[a]&&t[a].classList.remove("hideCheapCards")})});'
                }
            })
        ]
    });
}

;// CONCATENATED MODULE: ./containers/Body.js












function Body(props) {
    var data = (props || {}).data;
    var ref = data || {}, pageType = ref.pageType, isDeviceMobile = ref.isDeviceMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            pageType === "offerPage" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Offers, {
                data: data
            }),
            Constants/* flightsIsmDTNewPageType */.Py9[pageType] && !isDeviceMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(FlightRouteDT, {
                data: data
            }),
            Constants/* flightsIsmDTNewPageType */.Py9[pageType] && isDeviceMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(FlightRoutePWA, {
                data: data
            }),
            Constants/* fareFinderDTPageType */.T11[pageType] && /*#__PURE__*/ (0,jsx_runtime.jsx)(FareFinderDT, {
                data: data
            }),
            Constants/* flightIsm2PageType */.SAi[pageType] && !isDeviceMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(FlightDistanceDT, {
                data: data
            }),
            Constants/* flightIsm2PageType */.SAi[pageType] && isDeviceMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(FlightDistancePWA, {
                data: data
            }),
            Constants/* flightsStaticPageType */._j[pageType] && !isDeviceMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(CityDT, {
                data: data
            }),
            Constants/* flightsStaticPageType */._j[pageType] && isDeviceMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(CityPWA, {
                data: data
            }),
            Constants/* destinationPickerDTPageType */.eA_[pageType] && !isDeviceMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(CityCountryDT, {
                data: data
            })
        ]
    });
}
Body.propTypes = {
    // eslint-disable-next-line react/require-default-props, react/forbid-prop-types, react/no-unused-prop-types
    props: (prop_types_default()).object
};


/***/ })

}]);